import { Link } from 'react-router-dom';

interface BrandLogoProps {
  variant?: 'light' | 'dark';
  className?: string;
}

export default function BrandLogo({ variant = 'dark', className = '' }: BrandLogoProps) {
  const textColor = variant === 'light' ? 'text-background-50' : 'text-foreground-950';
  const subColor = variant === 'light' ? 'text-background-200' : 'text-foreground-500';

  return (
    <Link to="/" className={`flex items-center gap-2.5 group ${className}`} aria-label="蘑菇视频首页">
      <span className="w-10 h-10 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center font-heading font-black text-xl shadow-sm transition-transform group-hover:scale-105">
        蘑
      </span>
      <span className="flex flex-col leading-none">
        <span className={`font-heading font-black text-xl tracking-tight ${textColor}`}>蘑菇视频</span>
        <span className={`text-[10px] tracking-[0.2em] uppercase mt-0.5 ${subColor}`}>Mushroom Video</span>
      </span>
    </Link>
  );
}